import { AxiosError, RawAxiosRequestHeaders } from 'axios'
import { IAxiosErrorWrapper, IGenericResponse } from '../../types/service-types'
import { axiosErrorWrapper } from './axios-error-wrapper'

export function getHeaders(): RawAxiosRequestHeaders {
  const idToken: string = localStorage.getItem('fingerprint')
  console.log('idToken', idToken)
  const headers: RawAxiosRequestHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    fingerprint: idToken,
  }
  return headers
}

export const axiosResponseErrorInterceptor = async (error: AxiosError<IGenericResponse<null>>) => {
  const wrappedError: IAxiosErrorWrapper = axiosErrorWrapper(error)
  return Promise.reject(wrappedError)
}
